import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    name: 'notFound',
    path: '/:path(.*)+',
    redirect: {
      name: '404'
    }
  },
  {
    name: 'main',
    path: '/',
    redirect: "/home"
  },
  {
    name: 'home',
    path: '/home',
    component: () => import('@/view/HomeView.vue'),
    meta: {
      title: 'Catehism Gratia Dei'
    }
  },
  {
    name: 'sermons',
    path: '/sermons',
    component: () => import('@/view/SermonsView.vue'),
    meta: {
      title: 'Mesaje'
    }
  },
  {
    name: 'catechism',
    path: '/catechism',
    component: () => import('@/view/CatechismsView.vue'),
    meta: {
      title: 'Catehisme'
    }
  },
  {
    name: 'settings',
    path: '/settings',
    component: () => import('@/view/SettingsView.vue'),
    meta: {
      title: 'Optiuni'
    },
  },
  {
    name: 'copyrights',
    path: '/copyrights',
    component: () => import('@/view/CopyrightsView.vue'),
    meta: {
      title: 'Drepturi de autor'
    },
  }
]

const router = createRouter({
  routes,
  history: createWebHistory(),
})

router.beforeEach((to, from, next) => {
  const title = to?.meta?.title
  if (title) {
    document.title = title as string
  }
  next()
})

export default router
